
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { State } from "../../types/State";
import {
  CloseSupplySideBar,
  DropSync,
  DropTempHoverBuildingLevel,
  HideBuildingConfirm,
  IncreaseBuildingLevel,
  InitSounds,
  OpenSupplySideBar,
  SelectBuilding,
  SetBuildingLevel,
  SetHighlightedBuilding,
  SetMapBlur,
  SetMapRef,
  SetMapRefBg,
  SetMapZoom,
  SetSelectedBuilding,
  SetTempHoverBuildingLevel,
  ShowBuildingConfirm,
  UpdateMinZoom,
  UpdateSoundPosition,
  navigateToTreasury
} from "../Actions/ActionSupply";
import ViewSupply from "../Components/ViewSupply";
import { IsFromSearchContextConsumer } from '../Providers/IsFromSearch'
import { Point, PointArray } from "../Reducers/ReducerSupply";
import { addBlur, addMarkerBlur, removeBlur, updateBlurBgMap } from "../utils/mapUtils";
import { playClanBaseBuilding } from "../web2ClientAPI/web2ClientAPI";

export type ContainerSupply_Props = {
  balance: number;
  initialZoom: number;
  zoom: number;
  position: Point;
  initialMaxBounds: PointArray;
  maxBounds: PointArray;
  isMapBlured: boolean;
  buildings: any;
  selectedBuildingId: string | null;
  prevSelectedBuildingId: string | null;
  isSidebarOpened: boolean;
  tempHoverBuildingLevel: number | null;
  tempHoverBuildingId: string | null;
  buildingInProgress: string | null;
  isOwnBase: boolean;
  clanId: number;
  confirmBuildingId: string | null;
  hasBuildPermission: boolean;
  isAchievementsDialogVisible: boolean,
  minZoom: number;
  maxZoom: number;
  backgroundUrl: string | null;
  isDevMode: boolean;
  regularRewards: any,
  battlesStats: any,

  SetMapRef: (ref: any) => void;
  SetMapBlur: (isMapBlured: boolean) => void;
  SetSelectedBuilding: (buildingId: string | null) => void;
  NavigateToBuilding: (buildingId: string | null) => void;
  SetHighlightedBuilding: (buildingId: string | null) => void;
  SetMapZoom: (zoom: number) => void;
  OpenSupplySideBar: () => void;
  CloseSupplySideBar: () => void;
  IncreaseBuildingLevel: (buildingId: string) => void;
  SetBuildingLevel: (buildingId: string, level: number) => void;
  SetTempHoverBuildingLevel: (buildingId: string, level: number) => void;
  DropTempHoverBuildingLevel: (buildingId: string) => void;
  ShowBuildingConfirm: (buildingId: string) => void;
  HideBuildingConfirm: () => void;
  SelectBuilding: (buildingId: string, clanId: number | void, needSavePosition?: boolean) => void;
  ShowAchivements: () => void;
  HideAchivements: () => void;
  UpdateSoundPosition: () => void;
  InitSounds: () => void;
  UpdateMinZoom: () => void;
  DropSync: () => void;
  navigateToTreasury: () => void,
};
export type ContainerSupply_State = {};


window.L_NO_TOUCH = true;
window.L_DISABLE_3D = true;

class ContainerSupply extends PureComponent<ContainerSupply_Props, ContainerSupply_State> {


  map: any = null;
  highlightTimers = {};
  tooltipTimers = {};
  state = {};
  saveTooltip = false;

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  componentWillUnmount() {
    this.dropSelection();
    this.props.DropSync();
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    updateBlurBgMap(this.props.isSidebarOpened ? 400 : 0, true);
    this.props.UpdateMinZoom();
  };

  onZoomEnd = e => {
    this.props.UpdateSoundPosition();
    this.props.SetMapZoom(e.target._zoom);
  };

  dropSelection = () => {
    this.props.SetSelectedBuilding(null);
    this.props.HideBuildingConfirm();
  };

  updateBlur = () => {
    if (this.props.selectedBuildingId) {
      addBlur(this.props.selectedBuildingId);
      addMarkerBlur(this.props.selectedBuildingId);
    } else {
      removeBlur();
    }
  };

  setMapBgRef = ref => {
    this.map = ref;
  };

  onMapMove = e => {
    if (window.tooltipProvider) {
      const isTooltipShown = window.tooltipProvider.isVisible();
      if (isTooltipShown && window.tooltipProvider) {
        window.tooltipProvider.hide();
      }
    }
    this.props.UpdateSoundPosition();
  };

  increaseBuildingLevel = buildingId => () => {
    playClanBaseBuilding();
    this.props.IncreaseBuildingLevel(buildingId);
  };

  setSelectedBuilding = buildingId => () => {
    this.props.SetSelectedBuilding(buildingId);
  };

  setTempHoverLevel = (building: any) => (meta: any, level: number) => {
    this.props.SetTempHoverBuildingLevel(building.name, {
      ...meta,
      level: level
    });
  };

  dropTempHoverLevel = (building: any) => () => {
    if (this.props.tempHoverBuildingLevel) {
      this.props.DropTempHoverBuildingLevel(building.name);
    }
  };

  showBuildingConfirm = (building: any) => {
    this.props.ShowBuildingConfirm(building.name);
  };

  selectBuilding = (building: any, needSavePosition?: boolean) => {
    this.props.SelectBuilding(building, this.props.clanId, needSavePosition);
  };

  onMoveEnd = () => { };


  render() {
    this.updateBlur()
    return (
        <IsFromSearchContextConsumer>
            {isFromSearch => {
                return (
                    <ViewSupply
                        {...this.props}
                        isFromSearch={isFromSearch}
                        isOwnBase={this.props.isOwnBase}
                        selectBuilding={this.selectBuilding}
                        onMapMove={this.onMapMove}
                        onMoveEnd={this.onMoveEnd}
                        onZoomEnd={this.onZoomEnd}
                        dropSelection={this.dropSelection}
                        updateBlur={this.updateBlur}
                        highlightTimers={this.highlightTimers}
                        tooltipTimers={this.tooltipTimers}
                        increaseBuildingLevel={this.increaseBuildingLevel}
                        setSelectedBuilding={this.setSelectedBuilding}
                        setTempHoverLevel={this.setTempHoverLevel}
                        dropTempHoverLevel={this.dropTempHoverLevel}
                        showBuildingConfirm={this.showBuildingConfirm}
                    />
                )
            }}
        </IsFromSearchContextConsumer>
    )
  }
}

const mapStateToProps = (state: State, ownProps) => {
  const currentClanLadderInfo = state.clans.items[state.currentAccount.clanId];
  const activeClanLadderInfo = state.clans.items[ownProps.clanId]

  return {
    battlesStats: activeClanLadderInfo ? activeClanLadderInfo.stats : {},
    accumulativeResource: currentClanLadderInfo ? currentClanLadderInfo.accumulativeResource : 0,
    balance: currentClanLadderInfo ? currentClanLadderInfo.personalResource : 0,
    initialZoom: state.ReducerSupply.initialZoom,
    zoom: state.ReducerSupply.zoom,
    position: state.ReducerSupply.position,
    initialMaxBounds: state.ReducerSupply.initialMaxBounds,
    maxBounds: state.ReducerSupply.maxBounds,
    isMapBlured: state.ReducerSupply.isMapBlured,
    buildings: state.ReducerSupply.buildings,
    selectedBuildingId: state.ReducerSupply.selectedBuildingId,
    prevSelectedBuildingId: state.ReducerSupply.prevSelectedBuildingId,
    highlightedBuildingId: state.ReducerSupply.highlightedBuildingId,
    highlightDelay: state.ReducerSupply.highlightDelay,
    mapHost: state.ReducerSupply.mapHost,
    isSidebarOpened: state.ReducerSupply.isSidebarOpened,
    tempHoverBuildingLevel: state.ReducerSupply.tempHoverBuildingLevel,
    tempHoverBuildingId: state.ReducerSupply.tempHoverBuildingId,
    buildingInProgress: state.ReducerSupply.buildingInProgress,
    isOwnBase: ownProps.clanId === state.currentAccount.clanId,
    confirmBuildingId: state.ReducerSupply.confirmBuildingId,
    hasTooltipConflict: state.ReducerSupply.hasTooltipConflict,
    hasBuildPermission: state.ReducerSupply.hasBuildPermission,
    isAchievementsDialogVisible: state.ReducerSupply.isAchievementsDialogVisible,
    minZoom: state.ReducerSupply.minZoom,
    maxZoom: state.ReducerSupply.maxZoom,
    backgroundUrl: state.ReducerSupply.backgroundUrl,
    isDevMode: state.ReducerSupply.isDevMode,
    regularRewards: state.ReducerTreasury.regularRewards,
    edgesVisible: state.ReducerSupply.edgesVisible
  };


};

const mapDispatchToProps = dispatch => {
  return {
    SetMapRef: ref => {
      dispatch(SetMapRef(ref));
    },
    SetMapRefBg: ref => {
      dispatch(SetMapRefBg(ref));
    },
    SetMapBlur: isMapBlured => {
      dispatch(SetMapBlur(isMapBlured));
    },
    SetSelectedBuilding: buildingId => {
      dispatch(SetSelectedBuilding(buildingId));
    },
    SetHighlightedBuilding: buildingId => {
      dispatch(SetHighlightedBuilding(buildingId));
    },
    SetMapZoom: zoom => {
      dispatch(SetMapZoom(zoom));
    },
    OpenSupplySideBar: () => {
      dispatch(OpenSupplySideBar());
    },
    CloseSupplySideBar: () => {
      dispatch(CloseSupplySideBar());
    },
    SetBuildingLevel: (buildingId, level) => {
      dispatch(SetBuildingLevel(buildingId, level));
    },
    IncreaseBuildingLevel: buildingId => {
      dispatch(IncreaseBuildingLevel(buildingId));
    },
    SetTempHoverBuildingLevel: (buildingId, level) => {
      dispatch(SetTempHoverBuildingLevel(buildingId, level));
    },
    DropTempHoverBuildingLevel: buildingId => {
      dispatch(DropTempHoverBuildingLevel(buildingId));
    },
    ShowBuildingConfirm: buildingId => {
      dispatch(ShowBuildingConfirm(buildingId));
    },
    HideBuildingConfirm: () => {
      dispatch(HideBuildingConfirm());
    },
    SelectBuilding: (buildingId, clanId, needSavePosition) => {
      dispatch(SelectBuilding(buildingId, clanId, needSavePosition));
    },
    UpdateSoundPosition: () => {
      dispatch(UpdateSoundPosition());
    },
    InitSounds: () => {
      dispatch(InitSounds());
    },
    UpdateMinZoom: () => {
      dispatch(UpdateMinZoom());
    },
    DropSync: () => {
      dispatch(DropSync());
    },
    navigateToTreasury: () => {
      dispatch(navigateToTreasury())
    }

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContainerSupply);